export enum ClientPlatform {
	IOS = 'IOS',
	ANDROID = 'ANDROID',
	WEB = 'WEB',
}
